import { flow } from 'lodash/fp'

import { formatDate, parseDate } from '../../helpers'
import { Format } from '../../types/core'
import { CollectorReview } from './types'

export const formatReviewedAt: Format<CollectorReview['reviewedAt']> = flow(parseDate, date =>
  formatDate(date, 'd MMM yyyy'),
)
